const resetMatchCountForAllRecipes = ({ state }) => {
  state.mealPlanDays.forEach((mealPlanDay) => {
    mealPlanDay.matchCounts = []
  })
}

export default resetMatchCountForAllRecipes
